export const FETCH_ISSUE_SEARCH_ERROR = 'FETCH_ISSUE_SEARCH_ERROR'
export const FETCH_ISSUE_SEARCH_REQUEST = 'FETCH_ISSUE_SEARCH_REQUEST'
export const FETCH_ISSUE_SEARCH_SUCCESS = 'FETCH_ISSUE_SEARCH_SUCCESS'

export const FETCH_ISSUES_REQUEST = 'FETCH_ISSUES_REQUEST'
export const FETCH_ISSUES_SUCCESS = 'FETCH_ISSUES_SUCCESS'
export const FETCH_ISSUES_ERROR = 'FETCH_ISSUES_ERROR'
